import { render, staticRenderFns } from "./list.vue?vue&type=template&id=14d11134&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d11134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14d11134')) {
      api.createRecord('14d11134', component.options)
    } else {
      api.reload('14d11134', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=14d11134&scoped=true", function () {
      api.rerender('14d11134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/reunionDinnerManagement/dishRoomsManagement/list.vue"
export default component.exports